export default __webpack_public_path__ + "static/media/icon_check.ebe0a616.svg";